// extracted by mini-css-extract-plugin
module.exports = {"trailersWrapper":"sl","trailerHeader":"sm","trailers":"sn","trailer":"so","imgWrapper":"sp","playWrapper":"sq","playImg":"sr","title":"ss","slipnslideArrow":"st"};